import React from 'react';
import Box from '@mui/material/Box';

import BaseHero from '#components/Hero';
import type { BackgroundDefinition } from '#components/Section';
import type { ColorIndex } from '#components/Layout';
import type { ButtonDefinition } from '#contentful/Button';
import type { ButtonGroupDefinition } from '../ContentfulComponent/ButtonGroup';
import type { AnimationsDefinition } from '../AnimationTexts';

export type HeadingProps = {
  overline?: string,
  title: string,
  subtitle?: string,
  titleFontSize?: string,
  text?: {
    text: string
  },
  button?: ButtonDefinition | ButtonGroupDefinition,
  background?: BackgroundDefinition,
  fontColor?: ColorIndex,
  addOverlay?: boolean,
  isSectionTallest?: boolean,
  extendContentWidth?: boolean,
  noTopMargin?: boolean,
  loading?: boolean,
  rightSection?: any,
  subtitleFontSize?: string
  subtitleMarginTop?: string
  leftSize?: number
  animations?: AnimationsDefinition,
};

/**
 * PageHeading is going to get the necessary properties from the object pass
 * to it as a prop and pass them to the Hero component. If the title prop is missing,
 * a placeholder heading element is going to be displayed with some info about what is
 * missing.
 *
 * The Hero component is going to display the page main title (H1),
 * subheading, etc. below the top navigation bar.
 *
 * Contentful Content Model: https://app.contentful.com/spaces/0vvalmm98slw/content_types/componentPageHeading/fields
 */
const PageHeading = ({
  overline,
  title,
  titleFontSize,
  subtitle,
  text,
  button,
  background,
  fontColor,
  addOverlay,
  isSectionTallest,
  extendContentWidth,
  noTopMargin,
  loading,
  rightSection,
  subtitleFontSize,
  subtitleMarginTop,
  leftSize,
  animations,
}: HeadingProps) => {
  if (!title || !background) {
    return (
      <Box sx={{ height: { xs: '191px', md: '464px' } }} />
    );
  }

  return (
    <BaseHero
      alignment="left"
      overline={overline}
      headline={title}
      titleFontSize={titleFontSize}
      subtitle={subtitle}
      info={text?.text}
      button={button}
      image={background?.image}
      fontColor={fontColor}
      addOverlay={addOverlay}
      isSectionTallest={isSectionTallest}
      extendContentWidth={extendContentWidth}
      noTopMargin={noTopMargin}
      loading={loading}
      rightSection={rightSection}
      subtitleFontSize={subtitleFontSize}
      subtitleMarginTop={subtitleMarginTop}
      leftSize={leftSize}
      animations={animations}
    />
  );
};

export default PageHeading;
